export default "__VITE_ASSET__SKBbSSW9__"